import React, { Component } from 'react';
import AdminCompaniesDetailView from '../views/AdminCompaniesDetailView';
import { base } from '../../base';

class AdminCompaniesDetailContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            company: {},
            users: [],
        };
    }

    componentDidMount() {
        const { params } = this.props.match;
        this.companyRef = base.syncState(`companies/${params.companyId}`, {
            context: this,
            state: 'company',
            asArray: false,
        });
        this.companyUsersRef = base.syncState('users/', {
            context: this,
            state: 'users',
            asArray: true,
            queries: {
                orderByChild: 'companyid',
                equalTo: params.companyId,
            },
        });
    }

    componentWillUnmount() {
        base.removeBinding(this.companyRef);
        base.removeBinding(this.companyUsersRef);
    }

    render() {
        const { params } = this.props.match;
        return (
            <AdminCompaniesDetailView
                companyid={params.companyId}
                company={this.state.company}
                users={this.state.users}
            />
        );
    }
}

export default AdminCompaniesDetailContainer;



// WEBPACK FOOTER //
// ./src/components/containers/AdminCompaniesDetailContainer.js